import { Outlet, matchPath } from "react-router-dom";
import AuthorizedLayout from "../../features/layout/auth/AuthorizedLayout";

const ResolvePages = ({ path }: { path: string }): JSX.Element => {
  const pages = [
    { path: "/", screen: <Outlet /> },
    { path: "/login", screen: <Outlet /> },
    { path: "/register", screen: <Outlet /> },
    { path: "/callback", screen: <Outlet /> },
    { path: "/change-password", screen: <Outlet /> },
    { path: "/verifyemail", screen: <Outlet /> },
    { path: "/vendors", screen: <Outlet /> },
    { path: "/vendors/:id", screen: <Outlet /> },
    { path: "/not-found", screen: <Outlet /> },
  ] as const;

  const screen = pages.find((page) => matchPath(page.path, path));

  if (screen !== undefined) {
    return screen.screen;
  } else {
    return (
      <AuthorizedLayout>
        <Outlet />
      </AuthorizedLayout>
    );
  }
};

export default ResolvePages;
